import React, {Component} from 'react';
const { connect } = require('react-redux');

import {Link, NavLink} from 'components/ReactRouterDomLocalized';

import '../../sass/headers/header.scss';

import {t, dt} from 'l10n';

import paths from 'paths';

class HeaderWallet extends Component {
    constructor(props) {
        super(props);
        this.state = {

        }
    }

    render() {
        let {replenish, currentUser, virtualGifts, amountAvailable} = this.props;

        let headermenu = (
            <div className="list-wallet">
                <NavLink exact to={paths.memberWallet.path} activeClassName="active">{t('Pending gifts')} ({virtualGifts.list.length})</NavLink>
                <NavLink exact to={paths.memberWalletHistory.path} activeClassName="active">{t('History')}</NavLink>
            </div>
        );

        let replenishblock = (
            <div>
                <Link to={paths.memberWalletReplenish.path + "?return_path=/membre/wallet"} className="replenish">{t('Replenish')}</Link>
            </div>
        );

        if (replenish) {
            headermenu = (
                <div className="list-wallet">
                    <Link to={paths.memberWallet.path}>{t('Back')}</Link>
                </div>
            );
            replenishblock = (<div></div>);
        }

        return (
            <header className="headerWallet">
                <div className="content">
                    <h1>{t('My wallet')}</h1>
                    <div className="text-headerWallet">
                        {headermenu}
                        <div className="info-wallet">
                            {amountAvailable ?
                                <div className="points">
                                    {t('%1 points', amountAvailable)}
                                </div>
                            : null}
                            {replenishblock}
                        </div>
                    </div>
                    <div className="footer-wallet">
                        <p>{t('Your virtual wallet contains tokens.')}</p>
                        <p>{t('You can purchase these tokens by crediting your virtual wallet by a secure online payment.')}</p>
                        <p>{t('The validity duration of the tokens is unlimited. You can use them in two ways:')}</p>
                        <p>{t('- to give virtual gifts to the users of your choice. Then they will get popularity stars (blue, red or gold).')}</p>
                        <p dangerouslySetInnerHTML={{__html:t('- to offer tokens directly to the users of your choice. They will be able to shop at the %2 by paying them with their accumulated tokens and you will get a medal of generosity (blue, red or gold).', '<a href="https://bobstore.fr" target="_blank">Bobstore</a>')}} />
                    </div>

                </div>
            </header>
        )
    }
}

export default connect(
    state => ({
        currentUser: state.currentUser,
        history: state.memberWallet.history,
        virtualGifts: state.memberWallet.virtualGifts,
        amountAvailable: state.memberWallet.amountAvailable,
    }),({

    })
)(HeaderWallet)




// WEBPACK FOOTER //
// ./src/components/wallet/HeaderWallet.js